export default {"src":"/_next/static/media/BIRK.7890b13d.svg","height":18,"width":18};